// CommonSnackbar.js
import React, { SyntheticEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { closeSnackbar } from "../../store/snackBarSlice";
import { RootState } from "../../store/appStore";
import { AlertColor } from "@mui/material";

const CommonSnackbar: React.FC = () => {
	const dispatch = useDispatch();
	const { open, message, severity } = useSelector(
		(state: RootState) => state.snackbar,
	);
	const alertSeverity: AlertColor = severity as AlertColor;
	const handleClose = (
		event: React.SyntheticEvent | Event,
		reason?: string,
	): void => {
		if (reason === "clickaway") {
			return;
		}
		dispatch(closeSnackbar());
	};

	return (
		<Snackbar
			open={open}
			autoHideDuration={5000}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			onClose={handleClose}
		>
			<Alert
				onClose={handleClose}
				severity={alertSeverity}
				variant="filled"
				sx={{ width: "100%" }}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default CommonSnackbar;
